var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        { attrs: { size: "small" } },
        [
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("GlobalSetObj.operationTime") } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          clearable: true,
                          "default-time": ["00:00:00", "23:59:59"],
                          format:
                            _vm.$i18n.locale === "zh" ? _vm.zhDate : _vm.ptDate,
                          placeholder: _vm.$t("newOrder.SelectDatetime"),
                          "start-placeholder": _vm.$t(
                            "collectionCenter.StartTime"
                          ),
                          "end-placeholder": _vm.$t("collectionCenter.EndTime"),
                          "range-separator": "~",
                          type: "datetimerange",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                        },
                        model: {
                          value: _vm.timeArr,
                          callback: function ($$v) {
                            _vm.timeArr = $$v
                          },
                          expression: "timeArr",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("mdfeTranslate.PackageNumber") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          placeholder: _vm.$t("collectionCenter.pleaseInput"),
                        },
                        model: {
                          value: _vm.queryForm.params.waybillNumber,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryForm.params, "waybillNumber", $$v)
                          },
                          expression: "queryForm.params.waybillNumber",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("el-col", { attrs: { span: 6 } }, [
                _c(
                  "div",
                  { staticStyle: { "margin-top": "30px" } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "small" },
                        on: { click: _vm.handleQuery },
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$t("collectionCenter.search")) + " "
                        ),
                      ]
                    ),
                    _c(
                      "el-button",
                      { attrs: { size: "small" }, on: { click: _vm.onReset } },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$t("collectionCenter.reset")) + " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm.rowData.status !== 2
        ? _c(
            "div",
            { staticStyle: { "margin-bottom": "10px" } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.removeBag },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("compensationManagement.Remove")) + " "
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                border: "",
                "header-cell-style": { background: "#ebebeb", color: "#000" },
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "selection",
                  width: "55",
                  align: "center",
                  fixed: "left",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("CenterForSorting.ind"),
                  align: "center",
                  width: "80px",
                  fixed: "left",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.$index + 1))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("mdfeTranslate.PackageNumber"),
                  align: "center",
                  prop: "waybillNumber",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("GlobalSetObj.operationTime"),
                  align: "center",
                  prop: "operationTime",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.operator"),
                  align: "center",
                  prop: "operationName",
                },
              }),
            ],
            1
          ),
          _c("el-pagination", {
            staticStyle: { margin: "10px 0", float: "right" },
            attrs: {
              "current-page": _vm.queryForm.pageNumber,
              "page-size": _vm.queryForm.pageSize,
              "page-sizes": [10, 20, 50, 100],
              total: _vm.total,
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("collectionCenter.tips"),
            visible: _vm.showRemoveWindow,
            width: "600px",
            "append-to-body": true,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            top: "5%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showRemoveWindow = $event
            },
          },
        },
        [
          _c("div", [
            _c(
              "div",
              { staticStyle: { "margin-bottom": "20px", "font-size": "18px" } },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t(
                        "collectionCenter.PleaseConfirmRemovalPackageNumber"
                      )
                    ) +
                    " "
                ),
              ]
            ),
            _c(
              "div",
              { staticStyle: { height: "300px", "overflow-y": "auto" } },
              _vm._l(_vm.selectedData, function (item, index) {
                return _c(
                  "div",
                  { key: index, staticStyle: { "margin-bottom": "10px" } },
                  [_vm._v(_vm._s(item.waybillNumber))]
                )
              }),
              0
            ),
          ]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.handleRemoveConfirm },
                },
                [_vm._v(" " + _vm._s(_vm.$t("collectionCenter.Confirm")) + " ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.showRemoveWindow = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.close")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }